import { Page } from '@/core/architecture'

import { ConsoleUserOwnedItemDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleUserOwnedItemDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleUserOwnedItemDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleUserOwnedItemDetailTemplate state={state} {...actions} />
}
